import { TypedDefinition } from '@rehaje/core'

import type { TypedSchema } from '@rehaje/core'

export class ActionCallPageDefinition extends TypedDefinition {
  override extends = ['Action']
  override properties: TypedSchema[] = [
    {
      name: 'props',
      properties: [
        {
          name: 'url',
          type: 'Schema.Union',
          types: [
            {
              expect: {
                type: 'Schema.String'
              },
              type: 'Schema.Mustache'
            },
            {
              type: 'Schema.String'
            }
          ]
        },
        {
          name: 'params',
          type: 'Schema.Union',
          types: [
            {
              expect: {
                type: 'Schema.Object'
              },
              type: 'Schema.Mustache'
            },
            {
              type: 'Schema.Object'
            }
          ]
        },
        {
          name: 'openWay',
          type: 'Schema.Union',
          types: [
            {
              expect: {
                type: 'Schema.String'
              },
              type: 'Schema.Mustache'
            },
            {
              type: 'Schema.String'
            }
          ]
        }
      ],
      type: 'Schema.Object'
    }
  ]

  override relationTo = 'Schema.Action'
}
